import React, { useRef } from 'react';
import { LoanPhases, Phases } from 'scenes/Private/Dashboard/LoanPhases.constanst';
// Components
import { PhaseModal } from './components/PhaseModal';
import { TabBarProgress } from './components/SharedComponents';
// Hooks
import { useClickOutside } from '@common/utils/hooks/useClickOutside';
import { useLoanPhases } from './useLoanPhases';

// Types
interface Props {
  loan: any;
  rulesTasksCards: any[];
  phaseSelect: string;
  handlerSetPhaseSelect: any;
  handlerSetTaskOpenModal: any;
  handlerSetFilter: any;
  handlerSetProgressData: any;
  setShowLoanDetailsModal: any;
}

const LoanProgress = ({
  loan,
  rulesTasksCards,
  handlerSetPhaseSelect,
  handlerSetTaskOpenModal,
  handlerSetProgressData,
  setShowLoanDetailsModal
}: Props) => {
  const divOpen = useRef<HTMLDivElement>(null);
  
  const {
    phases,
    phaseSelect,
    setPhaseSelect,
    tasks,
    loanDocs
  } = useLoanPhases({
    loan,
    rulesTasksCards,
    handlerSetProgressData
  });

  // Close modal when clicking outside
  useClickOutside(divOpen, () => setPhaseSelect(undefined));

  const onClickPhaseProgress = (phase: LoanPhases) => {
    const newPhaseSelect = phase.id === phaseSelect?.id ? undefined : phase;
    setPhaseSelect(newPhaseSelect);

    if (phase.key === Phases.APPROVAL || phase.key === Phases.DUE_DILIGENCE) {
      handlerSetPhaseSelect(phase.key);
    }
  };

  return (
    <section className="LoanProgress">
      {phases?.map((tab: any) => (
        <div
          className={`tab tab-${tab.state}`}
          key={tab.key}
          onClick={() => onClickPhaseProgress(tab)}
        >
          <TabBarProgress tab={tab} />
        </div>
      ))}

      {phaseSelect && (
        <div className='tab-open-content' ref={divOpen}>
          <PhaseModal
            loan={loan}
            phaseSelect={phaseSelect}
            phases={phases}
            tasks={tasks || []}
            loanDocs={loanDocs || []}
            onClickPhaseProgress={onClickPhaseProgress}
            handlerSetTaskOpenModal={handlerSetTaskOpenModal}
            setShowLoanDetailsModal={setShowLoanDetailsModal}
          />
        </div>
      )}
    </section>
  );
};

export default LoanProgress;